export const HOUSEHOLD_MEMBER_TYPES = {
  PROSPECT: 'prospect',
  FINANCIALLY_RESPONSIBLE: 'financiallyResponsible',
  NOT_FINANCIALLY_RESPONSIBLE: 'notFinanciallyResponsible',
};
